import { render, staticRenderFns } from "./materMove_Detail.vue?vue&type=template&id=6482cd07&"
import script from "./materMove_Detail.vue?vue&type=script&lang=js&"
export * from "./materMove_Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports